import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { IWarehouse } from "../../warehouses.types";
import { requestCreateWarehouse } from "./createWarehouse.request";

const useCreateWarehouse = (
  options?: MutationOptions<IWarehouse, ApiServiceError<ApiError>>,
) => {
  return useMutation({
    mutationFn: requestCreateWarehouse,
    ...options,
  });
};

export default useCreateWarehouse;
